import classNames from 'classnames';

import type { PercentageBarItem } from '@/components/organisms/PercentageBars';
import PercentageBars from '@/components/organisms/PercentageBars';

import type { WelfareLineChartDataset } from './WelfareLineChart';
import WelfareLineChart from './WelfareLineChart';

import styles from './WelfareCard.module.scss';

export interface WelfareCardProps {
    isLoading?: boolean;
    barsTitle: string;
    barsItems: PercentageBarItem[];
    chartDatasets: WelfareLineChartDataset[];
    decimals?: number;
    isPdfExport?: boolean;
}

export default function WelfareCard(props: WelfareCardProps) {
    const {
        barsTitle,
        barsItems,
        chartDatasets,
        isLoading = false,
        decimals = 0,
        isPdfExport = false,
    } = props;

    return (
        <div className={classNames(styles.welfareCard, { [styles.responsive]: !isPdfExport })}>
            <PercentageBars
                title={barsTitle}
                items={barsItems}
                isLoading={isLoading}
                decimals={decimals}
            />
            <WelfareLineChart
                className={styles.developmentGraph}
                datasets={chartDatasets}
                decimals={decimals}
                isLoading={isLoading}
            />
        </div>
    );
}
